import api from './base';

class HidProvisioningApi {
  private path = '/hid-provisioning';

  public create = async (params: any) => {
    const { data } = await api.post(this.path, params);
    return data;
  };

  public patch = async (id: string) => {
    const { data } = await api.patch(`${this.path}/${id}`);

    return data;
  }
}

export default new HidProvisioningApi();
